/**
 * Loader used to async loading of assets
 */
export default class Loader {
    
    constructor() {}
    
    load(slug, ...args) {
        let name = '__' + slug
        if (typeof this[name] === 'function') {
            this[name](...args)
        }
    }
    
    __addtocalendar() {
        // if (!window.addtocalendarStylesheetLoaded) {
        //   var link = document.createElement("link");
        //   link.setAttribute("rel", "stylesheet");
        //   link.setAttribute("type", "text/css");
        //   link.href = "http://addtocalendar.com/atc/1.5/atc-style-blue.css";
        //   document.head.appendChild(link);
        //   window.addtocalendarStylesheetLoaded = true;
        // }
        
        if (window.addtocalendar) {
            if (typeof window.addtocalendar.start === 'function') {
                return
            }
        }
        if (window.ifaddtocalendar === undefined) {
            window.ifaddtocalendar = 1
            var d = document, s = d.createElement('script'), g = 'getElementsByTagName'
            s.type = 'text/javascript'
            s.charset = 'UTF-8'
            s.async = true
            s.src = ('https:' == window.location.protocol ? 'https'
                                                          : 'http') + '://addtocalendar.com/atc/1.5/atc.min.js'
            var h = d[g]('body')[0]
            h.appendChild(s);
        }
    }
}
